import { makeRootStyles } from "../theme/styles";

const useStyles = makeRootStyles(
  {
    rootWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flexGrow: 1,
    },
    wrapper: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      width: "80%",
      paddingTop: "50px",
    },
    userActions: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      minWidth: "50%",
      width: "100%",
    },
    backButtonWrapper: {
      position: "absolute",
      top: "20px",
      left: 0,
      padding: "20px",
    },
  },
  { name: "ReturnReasons" },
);

export { useStyles };
